<template>
  <sw-modal :open="open" @close="$emit('close')">
    <div class="image-wrapper">
      <div class="flex center-y">
        <sw-button
          icon="plus"
          font="fa"
          label="image"
          class="image-wrapper-top-import-image center mr-5"
          @click="$refs.fupload.click()"
        />
        <sw-button
          icon="plus"
          font="fa"
          label="logo"
          class="image-wrapper-top-import-image center"
          @click="$refs.flogo.click()"
        />
        <input
          type="file"
          ref="fupload"
          multiple
          accept="image/*"
          @change="onUpload($event)"
          style="display: none"
        >
        <input
          type="file"
          ref="flogo"
          accept="image/*"
          @change="onUpload($event, true)"
          style="display: none"
        >

        <span class="mx-5">ou</span>
        <input
          ref="searchInput"
          class="image-wrapper-top-search-image"
          placeholder="Rechercher des photos sur Unsplash & Pixabay (anglais)..."
          @keyup.enter="search"
          v-model="lastSearch"
        >
      </div>
      <div class="image-wrapper-content" ref="imagesContainer">
        <ImageThumb
          v-for="img in pictureList"
          :key="img.image.thumb"
          :image="img"
          @click="selectImage"
          class="image-picture"
        />
      </div>
      <sw-button label="Charger plus de photos" class="more-picture" @click="morePicture"/>
    </div>
  </sw-modal>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////
import { mapGetters, mapActions } from 'vuex'
import HttpConnector from '@/model/http/HttpConnector'
import ImageThumb from '@/components/images/ImageThumb'
import Loader from '@/components/loaders/Loader'
import { debounce, gte, gt } from 'junctions-fp'
import { EventBus, PAYMENT_INFO, TEMPLATE_MODIFIED } from '@/model/EventBus'
//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'imagemodal',
  components: {
    Loader,
    ImageThumb
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  async mounted() {
    this.editor.on('imageLoaded', this.onImageLoadEditor)
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    this.editor.off('imageLoaded', this.onImageLoadEditor)
  },
  destroyed() {},
  data() {
    return {
      pictureList: [],
      containerImageSize: 0,
      inputSearch: '',
      isLoading: true,
      currentPage: 1,
      debounceSearch: null, //debounce(value => this.callUnSplashApi(value), 500),
      currentLoadedImg: [],
      firstOpen: false,
      lastSearch: ''
    }
  },
  props: {
    editor: Object,
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['getLimitations'])
  },
  methods: {
    ...mapActions(['getUnsplash']),
    async callUnSplashApi(value, oldArray = []) {
      //this.isLoading = true
      const result = await this.getUnsplash({ search: value, page: this.currentPage })
      //this.isLoading = false
      const a = result.data.results ? result.data.results : result.data
      this.pictureList = [...oldArray, ...a]

      if (this.$refs.imagesContainer) {
        this.$nextTick(() => {
          this.$refs.imagesContainer.scrollTop = this.$refs.imagesContainer.scrollHeight
        })
      }
    },
    async selectImage(value) {
      this.currentLoadedImg = [...this.currentLoadedImg, value]
      if (this.getLimitations.maxImages !== -1 && gte(this.getLimitations.maxImages, this.editor.getImagesCount())) {
        EventBus.$emit(PAYMENT_INFO, { type: 'infos', code: 'paymentContent', class: 'danger' })
        this.$emit('close')
        return
      }
      if (value.image.download_link) {
        HttpConnector.getInstance().unsplashDlIncrement(value.image.download_link)
      }
      if (value.image.provider === 'Pixabay') {
        const blob = await HttpConnector.getInstance().pixabayBase64(value.image.image.medium)
        this.editor.loadImage(blob)
      } else {
        this.editor.loadImage(value.image.image.medium)
      }
    },
    async search() {
      this.currentPage = 1
      this.pictureList = []
      this.callUnSplashApi(this.lastSearch)
    },
    morePicture() {
      if (this.getLimitations.onlineSearchImageLimit < 0) {
        this.currentPage++
        this.callUnSplashApi(this.lastSearch, this.pictureList)
        return
      }
      EventBus.$emit(PAYMENT_INFO, { type: 'infos', code: 'paymentContent', class: 'danger' })
    },
    onFileUpload(image, isLogo = false) {
      EventBus.$emit(TEMPLATE_MODIFIED)
      this.editor.loadImage(image, isLogo)
    },
    onUpload(evt, isLogo = false) {
      const images = [...evt.target.files]
      if (isLogo) {
        images.forEach(element => this.onFileUpload(element, isLogo))
        return
      }
      if (this.getLimitations.maxImages !== -1 && gt(this.getLimitations.maxImages, this.editor.getImagesCount() + images.length)) {
        EventBus.$emit(PAYMENT_INFO, { type: 'infos', code: 'paymentContent', class: 'danger' })
        this.$emit('close')
        return
      }
      images.forEach(element => this.onFileUpload(element))
    },
    onImageLoadEditor(value){
      if (value.type) {
        this.$emit('close')
        return
      }
      const data = this.currentLoadedImg.find(data => data.image.image.large === value._element.src)
      data.thumb.isClicked = false
      this.currentLoadedImg = this.currentLoadedImg.filter(data => data.image.image.large !== value._element.src)
      this.$emit('close')
    }
  },
  watch: {
    open: function(n, o) {
      if (n && this.firstOpen === false) {
        this.callUnSplashApi()
        this.firstOpen = true
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/modal/ImageModal.vue